import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { IFormValues } from "../../../../types";
import { ReactQueryKey } from "../../../../../../types";
import { getCountries } from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";
import {getRequiredVatNr} from "../../../../../../utils";

const VatNumberCountry = (props: { disabled: boolean }) => {
    const { t } = useTranslation('booking');

    const legalEntity = useWatch<IFormValues, "invoice.legalEntity">({
        name: 'invoice.legalEntity'
    });

    const countriesQuery = useQuery({
        queryKey: [ReactQueryKey.Countries],
        queryFn: getCountries,
        refetchOnMount: false
    });

    return (
        <FormAutocomplete<IFormValues>
            name="invoice.vatNumberCountry"
            label={t('label.vatNumberCountry') + (getRequiredVatNr(legalEntity?.code) ? '*' : '')}
            options={countriesQuery.data ?? []}
            isOptionEqualToValue={(option, value) => option === value}
            disabled={props.disabled}
        />
    )
}

export default VatNumberCountry;
